/* How the card's amount-due badge draws the coverage status chosen in the
   payment modal. The keys are the codes stored in `deductiblemet` (see
   COVERAGE_OPTIONS in modals/payments.jsx); they are data, not colours.
   With nothing chosen yet the badge keeps its Coinsurance look. */
const COVERAGE_STATUS = {
  "58D68D": { label: "Covered", color: "#2e9e62" },
  F9E79F: { label: "Coinsurance", color: "#e17954" },
  F3082C: { label: "Deductible", color: "#6d54a2" },
};

export const coverageStatus = (code) =>
  COVERAGE_STATUS[String(code || "").replace("#", "").trim().toUpperCase()] ||
  COVERAGE_STATUS.F9E79F;
